import React, {useEffect, useState} from 'react';
import {ContainerHeader} from "../../module";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import Button from "@mui/material/Button";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router";
import useValidation from "../../../validation/useValidation";
import {Link} from "react-router-dom";
import {styled} from '@mui/material/styles';
import {example_image_upload_handler} from "../../utils/uploaderTiny";
import {Editor} from "@tinymce/tinymce-react";
import {selToken, selUser} from "../../../stores/base/baseSlice";
import {initBlogForm, onBlogFormChange, selBlogForm} from "../../../stores/blog/slice";
import {blogValidations, FormBlogInit} from "../../../stores/blog/model";
import {createBlog, editBlog, getBlogById} from "../../../stores/blog/thunks";
import {uplaodFileFrom} from "../../../stores/uploader/uploadThunks";


const Input = styled('input')({
    display: 'none',
});

export default function Blog() {

    const blog = useSelector(selBlogForm);
    const user = useSelector(selUser);
    const token = useSelector(selToken);
    const [test, setTest] = useState('');
    const dispatch = useDispatch();
    const {id} = useParams();
    const history = useHistory();

    const {errors, checkFiled, checkValidation} = useValidation({
        data: blogValidations,
        key: 'blogForm',
    });

    function setParametersMain(event) {
        const {value, name} = event.target;
        checkFiled(name, value);
        dispatch(onBlogFormChange({name, value}))
    }

    function backToBlogs() {
        history.push('/blogs');
    }

    const redirectToBlogs =()=> history.push("/blogs")

    function addAgency(){
        const formData = new FormData();
        formData.append(`author_id`, user?.id)
        formData.append(`category`, blog.category)
        formData.append(`title`, blog.title)
        formData.append(`content`, blog.content)
        formData.append(`medias[0]`, blog.medias[0]?.key)

        dispatch(createBlog(formData, redirectToBlogs))
    }

    function putAgency(){

        const formData = new FormData();
        formData.append(`author_id`, user?.id)
        formData.append(`category`, blog.category)
        formData.append(`title`, blog.title)
        formData.append(`content`, blog.content)
        formData.append(`medias[0]`, blog.medias[0]?.key)

        dispatch(editBlog(id, formData, redirectToBlogs))
    }



    useEffect(() => {
        id ?
            dispatch(getBlogById(id))
            :
            dispatch(initBlogForm(FormBlogInit))
        return ()=>{
            dispatch(initBlogForm(FormBlogInit))
        }
    }, [id])


    async function onDrop(event) {
        let allImages = [];
        const callback = (res) => {
            // allImages = [...medias, ...allImages, res];
            dispatch(onBlogFormChange({name: 'medias', value: [res]}))
        }

        dispatch(uplaodFileFrom({file:event.target.files[0]}, callback))
    }

    function handleImageUrl(media){
        if(media.id){
            return media.urls.main_pic
        }else return media.url
    }

    return (
        <Grid item xs={12}
              className="w-100 d-flex flex-column DivParentCreateProduct ContentCreateAttribute">
            <ContainerHeader
                data={{
                    filter: false,
                    backBtn: true,
                }}
                headerTitle="افزودن بلاگ"
                backBtnTitle="بازگشت"
                backBtnAction={backToBlogs}
                // filterAction={(value) => {
                //     handleSearch(value);
                // }}
            />

            <Paper className="parentContentCreateProduct">
                <div className="w-100">

                    <div className="w-100">
                        <div className="d-flex flex-column">
                            <Grid container spacing={2}
                                  className="d-flex flex-wrap divParentContentBasicInformation mt-4">
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'عنوان پست'}
                                        variant="outlined"
                                        name={'title'}
                                        value={blog?.title}
                                        error={errors.title}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'دسته بندی'}
                                        variant="outlined"
                                        name={'category'}
                                        value={blog?.category}
                                        error={errors.category}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    
                                    {blog?.medias.length !== 0 ?
                                    <div>
                                        <a href={handleImageUrl(blog?.medias[0])} target="_blank" className="ml-3">
                                            <Button variant="contained">
                                            نمایش تصویر
                                            </Button>
                                        </a>
                                        <Button variant="contained"
                                        onClick={()=>{
                                            dispatch(onBlogFormChange({name: 'medias', value: []}))
                                        }}
                                        >
                                        حذف تصویر
                                    </Button>

                                    </div> 
                                    :
                                    <label htmlFor="contained-button-file" className="mt-4">
                                            <Input onChange={onDrop} id="contained-button-file"
                                                   type="file"/>
                                            <Button variant="contained" component="span">
                                                آپلود فایل
                                            </Button>
                                    </label>
                                    }
                                </Grid>
                                <Grid item
                                      xs={12} lg={12}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <Editor
                                        apiKey={`qsxqm0d3cpymk5zrn2u5ujmpunlep67r3lctb7tjt6t2dpw4`}
                                        init={{
                                            plugins: 'link im00000000age code',
                                            toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | code | link image',
                                            file_browser_callback_types: 'image',
                                            images_upload_handler: function (blobInfo, success, failure, progress) {
                                                example_image_upload_handler(blobInfo, success, failure, progress, token)
                                            },
                                            height: 400
                                        }}
                                        value={blog.content}
                                        onEditorChange={(e) => dispatch(onBlogFormChange({
                                            name: 'content',
                                            value: e
                                        }))}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        <Button
                            variant="contained"
                            onClick={ id ? putAgency : addAgency }
                            className="continuationButtonCreateProduct mr-3 mt-5"
                        >
                            { id ? "ویرایش" : "ایجاد" }
                        </Button>
                    </div>
                </div>
            </Paper>
        </Grid>
    );
}
